import React from "react";

export const TransNode =
    ({ children, value, ...props }: any) => {
    return (
        <>{`${value ?? children}`.t(props)}</>
    );
};

export default TransNode;